export default __webpack_public_path__ + "static/media/gallery-wip-handle_01.6f34ee5e.jpg";